import { BodyType, Segment } from '../types/catalog';
import { LeadChannel, LeadStatus } from '../types/lead';
import { Settings } from '../types/admin';

export const bodyTypes: BodyType[] = ['SUV', 'Sedán', 'Hatchback', 'Pick-up', 'Utilitario'];
export const segments: Segment[] = ['Compacto', 'Mediano', 'Grande'];

export const priceBudgets = [
  { label: 'Hasta $30.000.000', value: 30000000 },
  { label: 'Hasta $40.000.000', value: 40000000 },
  { label: 'Hasta $50.000.000', value: 50000000 },
  { label: 'Hasta $70.000.000', value: 70000000 },
];

export const monthlyBudgets = [
  { label: 'Hasta $600.000', value: 600000 },
  { label: 'Hasta $900.000', value: 900000 },
  { label: 'Hasta $1.200.000', value: 1200000 },
  { label: 'Hasta $1.800.000', value: 1800000 },
];

export const downBudgets = [
  { label: 'Hasta $10.000.000', value: 10000000 },
  { label: 'Hasta $15.000.000', value: 15000000 },
  { label: 'Hasta $20.000.000', value: 20000000 },
  { label: 'Hasta $30.000.000', value: 30000000 },
];

export const termOptions = [12, 18, 24, 36, 48, 60];

export const downRanges = [
  'Menos de $5.000.000',
  'Entre $5.000.000 y $10.000.000',
  'Entre $10.000.000 y $20.000.000',
  'Más de $20.000.000',
];

export const employmentOptions = [
  'Relación de dependencia',
  'Monotributista',
  'Responsable inscripto / autónomo',
  'Jubilado/a o pensionado/a',
  'Otra situación',
];

export const seniorityOptions = ['Menos de 6 meses', 'Entre 6 meses y 1 año', 'Entre 1 y 3 años', 'Más de 3 años'];

export const leadStatusSteps: { id: LeadStatus; label: string; description: string }[] = [
  { id: 'recibida', label: 'Recibida', description: 'Registramos tu consulta.' },
  { id: 'en-revision', label: 'En revisión', description: 'Un analista está revisando la información.' },
  { id: 'derivada', label: 'Derivada a asesor', description: 'Un asesor comercial tomó tu caso.' },
  { id: 'contactada', label: 'Contactado', description: 'El asesor se comunicó con vos.' },
  { id: 'cerrada', label: 'Finalizada', description: 'La consulta fue cerrada.' },
];

export const channelLabels: Record<LeadChannel, string> = {
  vehiculo: 'Formulario de vehículo',
  whatsapp: 'WhatsApp',
  cotizacion: 'Solicitud de cotización',
  chequeo: 'Chequeo crediticio',
  comparador: 'Comparador',
  simulador: 'Simulador',
  contacto: 'Contacto comercial',
  banco: 'Beneficios bancarios',
  usado: 'Usado como parte de pago',
  flota: 'Ventas especiales / Flotas',
  entrega_pactada: 'Financiación 100% entrega pactada',
  scoring: 'Scoring rápido (BCRA)',
};

export const banks = [
  'Banco Nación',
  'Banco Provincia',
  'Banco Ciudad',
  'Santander',
  'Galicia',
  'BBVA',
  'Macro',
  'ICBC',
  'Credicoop',
  'Patagonia',
  'Supervielle',
  'Hipotecario',
  'Otro banco',
];

export const tradeInYears = Array.from({ length: 22 }, (_, i) => 2026 - i);

export const defaultSettings: Settings = {
  whatsapp: '5491156449518', // WhatsApp comercial VCARS: 11 5644-9518
  logoUrl: '',
  adminPin: 'vcars-admin',
  companyEmail: '',
};
